module.exports = __webpack_public_path__ + "static/media/wind.2486df5b.jpg";